import * as React from 'react';

function SvgVehicleUnknown(props: ISvgIcons) {
  return (
    <svg
      width={props.size}
      height={props.size}
      xmlns="http://www.w3.org/2000/svg"
      viewBox={'0 0 24 24'}
      {...props}
    >
      <g
        stroke={props.color}
        strokeWidth={props.weight}
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
        vectorEffect={'non-scaling-stroke'}
      >
        <path d="M3.203 6.358L4.952 2.46A2.251 2.251 0 017.061 1h8.882c.939-.001 1.78.58 2.109 1.46l1.751 3.9M1.752 12.8v1.7a1.5 1.5 0 103 0V13m-.375-3.75a.375.375 0 00-.375.375m.75 0a.375.375 0 00-.375-.375m0 .75a.375.375 0 00.375-.375m-.75 0c0 .207.168.375.375.375" />
        <path d="M21.6 7.75a3 3 0 00-2.6-1.5H4a3 3 0 00-3 3v2.25A1.5 1.5 0 002.5 13h6" />
        <circle cx={17} cy={17} r={6} />
        <path d="M15.5 15.5A1.5 1.5 0 1117 17v.75m0 1.875a.375.375 0 100 .75.375.375 0 000-.75h0" />
      </g>
    </svg>
  );
}

export default SvgVehicleUnknown;
